import { observer } from 'mobx-react-lite';
import React from 'react';

import { Button } from '@flixbus/honeycomb-react';

import { authStore } from 'auth/authStore';

import styles from './styles.module.css';

const AuthGuard = observer(({ children }) => {
	if (authStore.isAuthStatusLoading) return <div>Loading...</div>;
	if (authStore.needsLogin) {
		return (
			<Button
				type="button"
				appearance="secondary"
				extraClasses={styles.tryToLogin}
				size="md"
				onClick={() => authStore.login()}
			>
				Unauthorized try to Login
			</Button>
		);
	}

	return <>{children}</>;
});

export default AuthGuard;
